export const languages = [
  { code: "en", name: "english_", flag: "fi fi-gb" },
  { code: "sv", name: "swedish_", flag: "fi fi-se" },
  { code: "da", name: "danish_", flag: "fi fi-dk" },
  { code: "fi", name: "finnish_", flag: "fi fi-fi" },
  // { code: "lt", name: "lithuanian_", flag: "fi fi-lt" },
  // { code: "nl ", name: "dutch_", flag: "fi fi-nl" }
];
